import clsx from 'clsx'

import { Popup, type PopupProps } from '@fv/client-components'

type Props = Omit<PopupProps, 'portalToRoot'>

export const ShipperPopup = ({ classNames, ...props }: Props) => {
  return (
    <Popup
      {...props}
      portalToRoot
      classNames={{
        positioner: clsx('z-[9999]', classNames?.positioner),
        popup: clsx(
          'relative border-fv-blue-200 border-[.175rem] rounded-sm bg-white p-4 shadow-lg',
          'data-[side=bottom]:mt-[.8rem] data-[side=bottom]:origin-top',
          'data-[side=top]:mb-[.8rem] data-[side=top]:origin-bottom',
          classNames?.popup,
        ),
        arrow: clsx(
          'bg-white border-fv-blue-200 border-[.175rem] h-4 w-4 rotate-45',
          'data-[side=top]:border-l-0 data-[side=top]:border-t-0 data-[side=top]:-bottom-2.5',
          'data-[side=bottom]:border-r-0 data-[side=bottom]:border-b-0 data-[side=bottom]:-top-2.5',
          'data-[side=left]:border-l-0 data-[side=left]:border-b-0 data-[side=left]:-right-2.5',
          'data-[side=right]:border-r-0 data-[side=right]:border-t-0 data-[side=right]:-left-2.5',
          classNames?.arrow,
        ),
        trigger: classNames?.trigger,
      }}
    />
  )
}
